module.exports = __webpack_public_path__ + "static/media/gradoo.9e0d1b8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/gradoo.png
// module id = 399
// module chunks = 17